<template>
  <div class="home">
    <div
      id="catalog"
      :ref="sectionRefs[0]"
      class="home-categories-list"
    >
      <WrapperWithCard
        :enable-card="!isMobile"
        card-classname="home-categories-list__card"
      >
        <MainPageCategoriesList />
      </WrapperWithCard>
    </div>

    <div
      id="about"
      :ref="sectionRefs[1]"
    >
      <div
        v-if="mainText && allVendingMachines?.length"
        class="home-main-block"
      >
        <CCardWithBorder class="home-main-block__about">
          <CMarkedText
            :text="mainText"
            justify
          />
        </CCardWithBorder>

        <MapCard class="home-main-block__map" />
      </div>
    </div>

    <CPreloader v-if="!allVendingMachines?.length || !mainText" />

    <div
      id="machines"
      :ref="sectionRefs[2]"
      class="home-machines-list"
    >
      <CCardWithBorder>
        <MainPageMachinesList />
      </CCardWithBorder>
    </div>

    <div
      id="feedback"
      :ref="sectionRefs[3]"
      class="home-feedback-form"
    >
      <ContentTitle v-if="isMobile">Возврат товара</ContentTitle>

      <FeedbackForm />
    </div>
  </div>
</template>

<script lang="ts" setup>
  import { onMounted, onUnmounted, ref } from 'vue';

  import { getMainText } from '@/api/requests/MainText';
  import CCardWithBorder from '@/components/Cards/CCardWithBorder.vue';
  import { useVendingMachinesList } from '@/composables/useVendingMachinesList';
  import MainPageMachinesList from '@/components/mainPage/MainPageMachinesList.vue';
  import MainPageCategoriesList from '@/components/mainPage/MainPageCategoriesList.vue';
  import { useSectionTracking } from '@/composables/useSectionTracking';
  import { useRoute } from 'vue-router';
  import FeedbackForm from '@/components/FeedBackForm/FeedbackForm.vue';
  import CMarkedText from '@/components/CMarkedText/CMarkedText.vue';
  import CPreloader from '@/components/CPreloader/CPreloader.vue';
  import MapCard from '@/components/mainPage/MapCard.vue';
  import { useClientSize } from '@/composables/useClientSize';
  import ContentTitle from '@/components/text/ContentTitle.vue';
  import WrapperWithCard from '@/components/Cards/WrapperWithCard.vue';

  const { allVendingMachines } = useVendingMachinesList();
  const route = useRoute();
  const { isMobile } = useClientSize();

  const { links, scrollToSection, setupSectionsTracking, teardownSectionsTracking } =
    useSectionTracking();

  const mainText = ref<string | null>(null);

  // Теперь только refs для секций
  const sectionRefs = links.map(() => ref<HTMLElement | null>(null));

  getMainText().then(async text => {
    mainText.value = text;
  });

  onMounted(async () => {
    setupSectionsTracking(
      links.map((link, index) => ({
        id: link.id,
        elementRef: sectionRefs[index]
      }))
    );

    const to = route.query.to as string;

    if (to) {
      scrollToSection(to);
    }
  });

  onUnmounted(() => {
    teardownSectionsTracking();
  });
</script>

<style>
  .home-main-block {
    display: flex;
    justify-content: space-between;
    align-items: stretch;
    gap: 24px;
    margin-top: 42px;

    &__about {
      width: calc(50% - 22px);
      min-height: 500px;
      padding: 0;
      flex-shrink: 0;
      font-size: 18px;

      .c-marked-text {
        padding: 24px 40px;
      }
    }
  }

  .home-machines-list {
    margin-top: 42px;
  }

  .home-categories-list {
  }

  .home-feedback-form {
    margin-top: 42px;
    margin-bottom: 24px;
  }

  @media (--mobile) {
    .home-main-block {
      flex-direction: column;
      margin-top: 24px;
    }

    .home-main-block__about {
      width: auto;
      padding: 0 10px;
    }

    .home-machines-list {
      margin-top: 24px;
    }

    .home-feedback-form {
      margin-top: 24px;
      margin-bottom: 12px;
    }
  }

  .home-section-title {
    font-size: 26px;
    margin-bottom: 12px;
    font-weight: 500;
    color: #000;
  }

  @media (--mobile) {
    .home-main-block__map {
      order: -1;
    }

    .home-main-block__about {
      padding: 0;

      .c-marked-text {
        padding: 12px 10px;
      }
    }
  }
</style>
